export default function ExampleSection() {
  return (
    <section
      id="home"
      className="relative w-full min-h-[100svh] flex flex-col items-center justify-center overflow-hidden bg-[#0a0a0a] px-6 pt-40 pb-20"
    >
      <style>
        {`
          @keyframes drift-glow {
            0% { background-position: 0% 50%; transform: translate3d(0,0,0) scale(1); }
            50% { background-position: 100% 50%; transform: translate3d(0,-3vh,0) scale(1.06); }
            100% { background-position: 0% 50%; transform: translate3d(0,0,0) scale(1); }
          }
          @keyframes float-slow {
            0%, 100% { transform: translate3d(0,0,0) rotate(-2deg); }
            50% { transform: translate3d(0,-14px,0) rotate(-2deg); }
          }
        `}
      </style>

      {/* MAXIMALIST AMBIENT COLOR FIELD */}
      <div
        className="pointer-events-none absolute top-[-20%] right-[-15%] -z-10 h-[75vh] w-[75vh] rounded-[100%] blur-[150px] opacity-70"
        style={{
          background:
            "conic-gradient(from 180deg at 50% 50%, #ff5fae, #7c5cff, #35d6c0, #ffd166, #ff5fae)",
          backgroundSize: "200% 200%",
          animation: "drift-glow 11s ease-in-out infinite",
        }}
      />
      <div className="pointer-events-none absolute inset-0 -z-10 bg-[#0a0a0a]/60" />

      {/* CONTENT — asymmetric split, photo gets real presence */}
      <div className="relative z-10 grid w-full max-w-[1180px] grid-cols-1 items-center gap-14 lg:grid-cols-[1fr_auto] lg:gap-16">
        {/* TEXT */}
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
          <span className="text-[13px] font-medium tracking-wide text-white/50">
            Helin Akdoğan · Founder &amp; AI Engineer
          </span>

          <h1
            className="
              mt-5 text-white
              text-[42px] leading-[1.03]
              sm:text-[58px]
              lg:text-[80px] lg:leading-[0.97]
              font-semibold tracking-[-0.045em]
            "
          >
            I design, build, and ship
            <br />
            <span
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  "linear-gradient(90deg, #ff8bd6, #a78bfa, #35d6c0)",
              }}
            >
              AI products
            </span>{" "}
            that work
          </h1>

          <div className="mt-10 flex w-full max-w-[420px] flex-col gap-3 sm:w-auto sm:max-w-none sm:flex-row sm:items-center sm:gap-4">
            <a
              href="#projects"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-4 text-[15px] font-semibold text-black transition hover:bg-white/90"
            >
              View projects →
            </a>

            <a
              href="#contact"
              className="inline-flex items-center justify-center rounded-full px-8 py-4 text-[15px] font-semibold text-white/70 transition hover:text-white hover:bg-white/10"
            >
              Contact
            </a>
          </div>
        </div>

        {/* PHOTO — modest, tilted, glowing */}
        <div className="relative mx-auto w-full max-w-[200px] lg:ml-auto lg:mr-0 lg:max-w-[240px]">
          <div
            className="pointer-events-none absolute -inset-4 -z-10 rounded-[40px] opacity-50 blur-3xl"
            style={{
              background:
                "linear-gradient(135deg, #ff8bd6, #a78bfa 50%, #35d6c0)",
            }}
          />
          <div
            className="relative aspect-[4/5] w-full overflow-hidden rounded-[28px]"
            style={{ animation: "float-slow 7s ease-in-out infinite" }}
          >
            <img
              src="/photos/avatar.png"
              alt="Helin Akdoğan"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}
